import Layout from '@/layout'

const route = {
  path: '/ListnewLaunchGroup',
  component: Layout,
  redirect: '/ListnewLaunchGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'ListnewLaunchGroup',
  meta: {
    title: '快应用数据表',
    icon: 'QRM',
    roles: [
      // 'channel_release_report.managent'
      'quick_repoet_manage'
    ]
  },
  children: [
    {
      path: '/ListnewLaunchGroup/releaseGroupList/index',
      component: () => import('@/views/ListnewLaunchGroup/releaseGroupList/index.vue'),
      name: 'ListreleaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          // 'channel_release_group.index'
          'quick_release_groups.index'
        ]
      }
    },
    {
      path: '/ListnewLaunchGroup/bookOwnership/index',
      component: () => import('@/views/ListnewLaunchGroup/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍列表',
        icon: 'component',
        roles: [
          // 'channel_release_report.belong_list'
          'quick_report.belong_list'
        ]
      }
    },
    {
      path: '/ListnewLaunchGroup/bindingRelationList/index',
      component: () => import('@/views/ListnewLaunchGroup/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          // 'bind_channel.index'
          'quick_binds.index'
        ]
      }
    }, {
      path: '/ListnewLaunchGroup/reportList/index',
      component: () => import('@/views/ListnewLaunchGroup/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '每日报表',
        icon: 'component',
        roles: [
          // 'channel_release_report.bind_channel_report'
          'quick_report.bind_quick_report'
        ]
      }
    }, {
      path: '/ListnewLaunchGroup/totalReportList/index',
      component: () => import('@/views/ListnewLaunchGroup/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计列表',
        icon: 'component',
        roles: [
          // 'channel_release_report.bind_channel_total_report'
          'quick_report.total_quick_report'
        ]
      }
    }
  ]
}

export default route
